import type { Selection } from '../DataFinder';

/**
 * test to see if a given option is selected (i.e. if it is in the list of selections).
 *
 * @param selections an array of the current selections
 * @param categoryId the id of the category the option being tested
 * @param optionId the id of the option being tested
 * @returns true if the option is selected, false otherwise
 */

export function isItemSelected(
	selections: Selection[],
	categoryId: string,
	optionId: string,
): boolean {
	for (const selection of selections) {
		if (
			selection.categoryId === categoryId &&
			selection.optionId === optionId
		) {
			return true;
		}
	}

	return false;
}

/**
 * Get the current selection(s) for a given category.
 *
 * If the categoryId is "object-id", returns all selections for that category as an array (or undefined if none).
 * Otherwise, returns a single selection (or undefined) for other categories.
 *
 * @param selections an array of the current selections
 * @param categoryId the id of the category to get selections for
 * @returns an array of selections for "object-id", or a single selection (or undefined) for other categories
 */
export function getSelectionByCategory(
	selections: Selection[],
	categoryId: 'object-id',
): Selection[] | undefined;
export function getSelectionByCategory(
	selections: Selection[],
	categoryId: string,
): Selection | undefined;
export function getSelectionByCategory(
	selections: Selection[],
	categoryId: string,
): Selection[] | Selection | undefined {
	const catMatch = ({ categoryId: cId }) => cId === categoryId; // ? performs a match on categoryId
	if (categoryId === 'object-id') {
		const filtered = selections.filter(catMatch);
		return filtered.length ? filtered : undefined;
	}
	return selections.find(catMatch);
}
